import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import userService from "../services/user.service";

export const getLatestVideos = createAsyncThunk(
    "dashboard/latestVideos",
    async (queryParams, thunkAPI) => {
      try {
        const response = await userService.getLatestVideos()
        thunkAPI.dispatch(setMessage(response.data))
        return response.data.details
      } catch (err) {
        thunkAPI.dispatch(setMessage(err.response));
        return thunkAPI.rejectWithValue(err.response.data);
      }
    }
  )
 
  const initialState = { videos: [], isFetching: false, isFetched: false };

  const latestVideosSlice = createSlice({
    name: "latestVideos",
    initialState,
    extraReducers: {
      [getLatestVideos.fulfilled]: (state, action) => {
       state.videos = action.payload
       state.isFetching = false
       state.isFetched = true
      },
      [getLatestVideos.rejected]: (state, action) => {
        state.isFetching = false;
        state.isFetched = false;
      }
    },
  });
  
  const { reducer } = latestVideosSlice;
  export default reducer;